const REFUSAL_CODE_PATTERN = /^[a-z][a-z0-9_]{0,63}$/

function readRefusalCode(error: unknown): string | null {
  const code = (error as { response?: { data?: { code?: unknown } } } | null)?.response?.data?.code
  if (typeof code !== 'string' || !REFUSAL_CODE_PATTERN.test(code)) {
    return null
  }
  return code
}

export function chartSegmentViewToastMessage(error: unknown): string {
  const status = (error as { response?: { status?: number } } | null)?.response?.status
  if (status === 409) {
    return 'The report changed. Reload it before opening a segment.'
  }
  if (readRefusalCode(error) === 'unsupported_open_end') {
    return "Segmenting isn't available for open-ended questions yet."
  }
  return 'Could not load the segment view.'
}
